
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-advantageous",
      function () {
        return require("private-next-pages/our-advantageous/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-advantageous"])
      });
    }
  